var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.2946032%",
    y1: "7.14378135%",
    x2: "77.4895425%",
    y2: "92.9645916%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECDDC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C696",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.3913748,63.4996491 C41.6668749,63.4996491 40.9738751,63.2003992 40.4777502,62.6727743 L27.7123776,49.0779019 C26.7175028,48.0226521 26.7726278,46.3610274 27.8278776,45.3687776 C28.8857524,44.3765278 30.547377,44.4290277 31.5370019,45.4842775 L42.3651248,57.0106503 L64.4361206,32.855405 C65.4178704,31.7817802 67.0768701,31.7109052 68.1478699,32.687405 C69.2162447,33.6639048 69.2897446,35.3255295 68.3132448,36.3939043 L44.3286244,62.6438993 C43.8377495,63.1846492 43.1394996,63.4943991 42.4097498,63.4996491 L42.3913748,63.4996491 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02C_Login_Mobile",
    transform: "translate(-112.000000, -241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(89.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick02);
export default __webpack_public_path__ + "static/media/Tick_02.fd8bd5f4a2543c6c1aa35e54c33a323b.svg";
export { ForwardRef as ReactComponent };